import { Directive, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { InitResetPassword } from '../../../shared/+state';
import { emailPatternValidator } from '../../utils';

@Directive()
export abstract class PasswordForgotFormBaseComponent {
  protected submitAttempted = false;
  store = inject(Store);
  form = inject(FormBuilder).group({
    email: ['', [Validators.required, emailPatternValidator()]],
  });

  sendResetLink() {
    // Mark that submit has been attempted - this will trigger error display
    this.markSubmitAttempted();

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { email } = this.form.value;
    this.store.dispatch(
      InitResetPassword({
        email,
      })
    );
  }

  // Enhanced validation methods - only show errors after submit is attempted
  protected shouldShowFieldError(fieldName: string): boolean {
    if (!this.submitAttempted) {
      return false;
    }
    const control = this.form.get(fieldName);
    return !!control?.invalid;
  }

  protected getFieldErrorMessage(fieldName: string): string {
    const control = this.form.get(fieldName);
    if (!control?.errors) {
      return '';
    }

    if (control.errors['required']) {
      return 'forms.required_l';
    }
    if (control.errors['invalidEmail']) {
      return 'registration_email_valid_l';
    }
    return '';
  }

  protected getEmailErrorState(): boolean {
    return this.shouldShowFieldError('email');
  }

  protected markSubmitAttempted(): void {
    this.submitAttempted = true;
  }
}
